import React from 'react';
import {
    Image as ImageIcon,
    Music,
    Type,
    Volume2,
    Wand2,
    Plus,
    AlignLeft
} from 'lucide-react';

const LeftSidebar = ({
    onAddMedia,
    onAddMusic,
    onAddText,
    onRegenerateCaptions, // Static for now usually
    onAddSoundEffect, // Static
    onRegenerateScene // Generate Scene handler
}) => {
    const menuItems = [
        {
            label: 'Captions',
            icon: <AlignLeft className="w-5 h-5" />,
            onClick: onRegenerateCaptions,
            isStatic: false
        },
        {
            label: 'Media',
            icon: <ImageIcon className="w-5 h-5" />,
            onClick: onAddMedia,
            isStatic: false
        },
        {
            label: 'Music',
            icon: <Music className="w-5 h-5" />,
            onClick: onAddMusic,
            isStatic: false
        },
        {
            label: 'Text',
            icon: <Type className="w-5 h-5" />,
            onClick: onAddText, // Renamed from captions option as requested? Or just new Text functionality. 
            // User said: "rename our captions option as Text option" -> I'm assuming 'Add Text' is the label they want.
            isStatic: false
        },
        {
            label: 'Sound Effects',
            icon: <Volume2 className="w-5 h-5" />,
            onClick: onAddSoundEffect,
            isStatic: false
        },
        {
            label: 'Generate New Scene',
            icon: <Wand2 className="w-5 h-5" />,
            onClick: onRegenerateScene,
            isStatic: true
        }
    ];

    return (
        <div className="w-72 h-full bg-[#F9FAFB] dark:bg-[#111111] border-r border-[#E5E7EB] dark:border-white/10 flex flex-col overflow-y-auto min-h-0">
            <div className="p-4 flex-1 flex flex-col">
                {/* Header with Icon */}
                <div className="flex items-center gap-3 mb-2">
                    <div className="w-8 h-8 flex items-center justify-center bg-orange-500 rounded-lg shadow-sm">
                        <Plus className="w-5 h-5 text-white stroke-[3px]" />
                    </div>
                    <h2 className="text-sm font-bold uppercase tracking-widest text-gray-900 dark:text-white">Add Content</h2>
                </div>

                {/* Border After Heading */}
                <div className="border-b border-gray-100 dark:border-white/5 mb-4"></div>

                <div className="flex flex-col gap-2">
                    {menuItems.slice(0, -1).map((item, index) => (
                        <button
                            key={index}
                            onClick={item.onClick}
                            className="flex items-center gap-4 group text-left w-full hover:bg-orange-50 dark:hover:bg-orange-500/10 p-1.5 rounded-xl transition-all"
                        >
                            <div className="w-9 h-9 flex items-center justify-center rounded-xl bg-gray-50 dark:bg-white/5 border border-gray-100 dark:border-white/5 shadow-md group-hover:scale-105 group-hover:bg-white dark:group-hover:bg-white/10 transition-all duration-200">
                                <span className="text-gray-600 dark:text-gray-400 group-hover:!text-orange-500 transition-colors">
                                    {item.icon}
                                </span>
                            </div>
                            <span className="text-sm font-semibold text-gray-700 dark:text-gray-300 group-hover:!text-orange-500 transition-colors">
                                {item.label}
                            </span>
                        </button>
                    ))}

                    {/* Border Before Last Item - Reduced spacing */}
                    <div className="border-t border-gray-300 dark:border-white/5 pt-4 mt-4">
                        {menuItems.slice(-1).map((item, index) => (
                            <button
                                key={index}
                                onClick={item.onClick}
                                className="flex items-center gap-4 group text-left w-full hover:bg-orange-50 dark:hover:bg-orange-500/10 p-1.5 rounded-xl transition-all"
                            >
                                <div className="w-9 h-9 flex items-center justify-center rounded-xl bg-gray-50 dark:bg-white/5 border border-gray-100 dark:border-white/5 shadow-md group-hover:scale-105 group-hover:bg-white dark:group-hover:bg-white/10 transition-all duration-200">
                                    <span className="text-gray-500 dark:text-gray-400 group-hover:!text-orange-500 transition-colors">
                                        {item.icon}
                                    </span>
                                </div>
                                <span className="text-sm font-semibold text-gray-700 dark:text-gray-300 group-hover:!text-orange-500 transition-colors">
                                    {item.label}
                                </span>
                            </button>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LeftSidebar;
